export enum AzureRegion {
	WestUS2 = "WestUS2",
	EastUS = "EastUS",
	WestEurope = "WestEurope",
	AustraliaEast = "AustraliaEast",
	SwedenCentral = "SwedenCentral",
}